import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetMembershipsByEnterpriseIdMessages } from './messages';

export interface useGetMembershipsByEnterpriseIdOptions {
  shouldFetch?: boolean;
}

export function useGetMembershipsByEnterpriseId(
  enterpriseId: number | null | undefined,
  options?: useGetMembershipsByEnterpriseIdOptions,
) {
  const mergedOptions: useGetMembershipsByEnterpriseIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { membershipApi } = usePrivate();

  const results = useSWR(
    membershipApi && mergedOptions.shouldFetch
      ? `/api/Membership/GetMembershipsByEnterpriseId/${enterpriseId}`
      : null,
    () =>
      membershipApi?.apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
        enterpriseId!,
      ),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetMembershipsByEnterpriseIdMessages[
            'useGetMembershipsByEnterpriseId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetMembershipsByEnterpriseId> error fetching memberships.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !membershipApi;

  return { ...results, isLoadingOrValidating };
}
